import React, { useState } from 'react';
import UpdateResultForm from 'app/components/match/liveResult/UpdateResultForm';
import UpdateResultHeader from 'app/components/match/liveResult/UpdateResultHeader';
import { authorizedAPI } from 'app/services/api';
import { wsUpdateMatch } from 'app/routes/match/MatchPageActions';
import { handleResultSuccess } from 'app/actions/softTickerActions';
import { useSoftTickerContext } from 'app/hooks/useSoftTickerContext';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'app/hooks/reduxCreateSelectorHooks';
import isAxiosError from 'app/helpers/isAxiosError';
const storeResult = (matchSlug, final, data) => {
  return authorizedAPI.post("/matches/".concat(matchSlug, "/results/").concat(final ? 'final' : 'interim'), data);
};
const UpdateResult = _ref => {
  let {
    match,
    onClose,
    onResultChange
  } = _ref;
  const {
    softTickerData,
    dispatch
  } = useSoftTickerContext();
  const {
    fuPaUser
  } = useSelector(selectCurrentUser);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (formData, setFieldError) => {
    setLoading(true);
    try {
      const response = await storeResult(match.slug, formData.final, {
        minute: formData.minute,
        homeGoals: formData.homeGoals,
        awayGoals: formData.awayGoals
      });
      setLoading(false);
      const resultData = response.data;
      dispatch(handleResultSuccess(resultData));
      onResultChange(() => {
        var _ref2, _fuPaUser$firstName;
        return wsUpdateMatch({
          minute: resultData.minute,
          additionalMinute: resultData.additionalMinute,
          homeGoal: resultData.homeGoals,
          awayGoal: resultData.awayGoals,
          flags: ['softticker'],
          lastSofttickerReporter: {
            name: (_ref2 = (_fuPaUser$firstName = fuPaUser.firstName) !== null && _fuPaUser$firstName !== void 0 ? _fuPaUser$firstName : fuPaUser.lastName) !== null && _ref2 !== void 0 ? _ref2 : fuPaUser.name,
            id: fuPaUser.id
          },
          softtickerEventsReportableUntil: resultData.softtickerEventsReportableUntil
        });
      });
    } catch (error) {
      setLoading(false);
      if (isAxiosError(error)) {
        var _error$response;
        const errorData = (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error;
        if ((errorData === null || errorData === void 0 ? void 0 : errorData.code) === 422) {
          // Validation-Error
          const fields = errorData.fields;
          if (fields && Object.keys(fields).length) {
            Object.keys(fields).forEach(field => {
              var _fields$field$, _fields$field;
              const input = field;
              setFieldError(input, {
                type: 'custom',
                message: (_fields$field$ = (_fields$field = fields[field]) === null || _fields$field === void 0 ? void 0 : _fields$field[0]) !== null && _fields$field$ !== void 0 ? _fields$field$ : errorData.translated_message
              });
            });
            return;
          }
        }
        if (errorData !== null && errorData !== void 0 && errorData.translated_message) {
          return setError(errorData.translated_message);
        }
      }
      setError('Es ist ein unbekannter Fehler aufgetreten, versuchen sie es später erneut.');
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UpdateResultHeader, {
    match: match,
    resultData: null,
    "data-sentry-element": "UpdateResultHeader",
    "data-sentry-source-file": "UpdateResult.tsx"
  }), /*#__PURE__*/React.createElement(UpdateResultForm, {
    match: match,
    data: softTickerData.createResult,
    loading: loading,
    onClose: onClose,
    submissionError: error,
    onSubmit: handleSubmit,
    "data-sentry-element": "UpdateResultForm",
    "data-sentry-source-file": "UpdateResult.tsx"
  }));
};
export default UpdateResult;